import { render, staticRenderFns } from "./cdn-domain.vue?vue&type=template&id=afefe944&scoped=true"
import script from "./cdn-domain.vue?vue&type=script&lang=js"
export * from "./cdn-domain.vue?vue&type=script&lang=js"
import style0 from "./cdn-domain.vue?vue&type=style&index=0&id=afefe944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afefe944",
  null
  
)

export default component.exports